import React from "react";
import SideNav from "./SideNav";
import { Link } from "react-router-dom";

interface SidebarAdminProp {
  isToggled: boolean;
  toogleHandler: () => void;
  signOutHandler: () => void;
}

const Sidebar: React.FC<SidebarAdminProp> = ({
  isToggled,
  toogleHandler,
  signOutHandler,
}) => {
  return (
    <ul
      className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${
        isToggled ? "toggled" : ""
      }`}
      id="accordionSidebar"
    >
      {/* <!-- Sidebar - Brand --> */}
      <Link
        to="/store"
        className="sidebar-brand d-flex align-items-center justify-content-center"
      >
        <div className="sidebar-brand-icon rotate-n-15">
          <i className=" fab fa-apple"></i>
        </div>
        <div className="sidebar-brand-text mx-3">iStore</div>
      </Link>

      {/* <!-- Divider --> */}
      <hr className="sidebar-divider my-0" />

      {/* <!-- Nav Item - Dashboard --> */}
      <SideNav path="/dashboard" icon="fa-tachometer-alt">
        Dashboard
      </SideNav>

      {/* <!-- Divider --> */}
      <hr className="sidebar-divider" />

      {/* <!-- Heading --> */}
      <div className="sidebar-heading">Products</div>

      {/* <!-- Nav Item - Pages Collapse Menu --> */}
      <li className="nav-item">
        <Link
          className="nav-link collapsed"
          to="/dashboard/product"
          data-toggle="collapse"
          data-target="#collapseTwo"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>Products</span>
        </Link>
        <div
          id="collapseTwo"
          className="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Products </h6>
            <Link className="collapse-item" to="/dashboard/products">
              All Products
            </Link>
            <Link className="collapse-item" to="/dashboard/add_product">
              Add Product
            </Link>
          </div>
        </div>
      </li>

      {/* <!-- Divider --> */}
      <hr className="sidebar-divider" />

      {/* <!-- Heading --> */}
      <div className="sidebar-heading">Addons</div>

      {/* <!-- Nav Item - Pages Collapse Menu --> */}

      {/* <!-- Nav Item - Charts --> */}

      {/* <!-- Nav Item - Tables --> */}
      <li className="nav-item">
        <Link className="nav-link" to="/dashboard/orders">
          <i className="fas fa-fw fa-table"></i>
          <span>Transactions</span>
        </Link>
      </li>
      <li className="nav-item">
        <button className="btn nav-link" onClick={signOutHandler}>
          <i className="fas fa-fw fa-sign-out"></i>
          <span>Sign out</span>
        </button>
      </li>

      {/* <!-- Divider --> */}
      <hr className="sidebar-divider d-none d-md-block" />

      {/* <!-- Sidebar Toggler (Sidebar) --> */}
      <div className="text-center d-none d-md-inline">
        <button
          className="rounded-circle border-0"
          id="sidebarToggle"
          onClick={toogleHandler}
        ></button>
      </div>
      {/* <!-- End of Sidebar --> */}
    </ul>
  );
};

export default Sidebar;
